import {AlertIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'

import {Header, type HeaderProps} from './toolbar/Header'

type ErrorFallbackProps = Pick<HeaderProps, 'onChangeViewMode'>

export function ErrorFallback({onChangeViewMode}: ErrorFallbackProps) {
  return (
    <>
      {/* Allowing users to still change the view mode enables them to go back to plaintext mode if the hybrid editor crashes */}
      <Header onChangeViewMode={onChangeViewMode} />
      <Blankslate>
        <Blankslate.Visual>
          <AlertIcon size="medium" />
        </Blankslate.Visual>
        <Blankslate.Heading>Something went wrong</Blankslate.Heading>
        <Blankslate.Description style={{textAlign: 'center', maxWidth: '700px'}}>
          The hybrid Markdown editing experience is temporarily unavailable due to an unknown error. Please{' '}
          <Link inline href="https://github-grid.enterprise.slack.com/archives/C08M545RDCN">
            report this error
          </Link>{' '}
          to the team along with browser console logs, if possible.
        </Blankslate.Description>
      </Blankslate>
    </>
  )
}

try{ ErrorFallback.displayName ||= 'ErrorFallback' } catch {}